// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollView_scroll__3kZQK","marginMedium":"ScrollView_marginMedium__263lg","marginSmall":"ScrollView_marginSmall__1qAzd"};